export const getInfoCarouselId = (carouselId: number) => {
  return `infoCarousel${carouselId}Index`;
};
